import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-call-objective-selector',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './call-objective-selector.component.html',
  styleUrls: ['./call-objective-selector.component.scss'],
})
export class CallObjectiveSelectorComponent {
  /** The 3 AI-generated call objective options. */
  @Input() options: string[] = [];
  /** True once the user has selected one — hides the tiles. */
  @Input() confirmed = false;

  /**
   * Emitted when the user clicks an option.
   * The host component is expected to load it into the chat input so the user
   * can edit it before sending — not send it directly.
   */
  @Output() optionSelected = new EventEmitter<string>();

  onSelect(option: string): void {
    this.optionSelected.emit(option);
  }
}
